import styled from 'styled-components';

import ProgressBar from 'components/shared/ProgressBar';
import { colors } from 'styles/theme/colors';
import { LabelBold } from 'styles/typography';

type Props = {
  done: number;
  total: number;
  // The bar's width; it fills the row when omitted.
  barWidth?: number;
  // The unfinished bar's color. It turns green once every counted item is done.
  color?: string;
  fontSize?: number;
};

// A discharge checklist's progress: a bar and "done/total", on the patient story and the discharge
// calendar alike. Items marked not needed aren't in the total, so when every item is not needed it
// reads 0/0 and shows no bar.
export default function DischargeChecklistProgress({ done, total, barWidth, color, fontSize }: Props) {
  return (
    <Row>
      {total > 0 && (
        <BarContainer $width={barWidth} data-testid='discharge-checklist-progress'>
          <ProgressBar
            showLabel={false}
            height={4}
            max={total}
            value={done}
            color={color}
            backgroundColor={colors.black10}
          />
        </BarContainer>
      )}
      <Count $fontSize={fontSize} data-testid='discharge-checklist-count'>
        {done}/{total}
      </Count>
    </Row>
  );
}

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const BarContainer = styled.div<{ $width?: number }>`
  ${({ $width }) => ($width ? `width: ${$width}px;` : 'flex: 1;')}
`;

const Count = styled(LabelBold)<{ $fontSize?: number }>`
  margin-left: auto;
  ${({ $fontSize }) => ($fontSize ? `font-size: ${$fontSize}px;` : '')}
`;
